import { fetchJSONData } from '../_utils'
import { createAlert } from '../dom/window'

export const toggleLoading = (value) => {
  return {
    type: 'TOGGLE_LOADING',
    value: value,
  }
}

/**
 * Function to post copied discount data
 * Used on Wholesale > Discount & Promotions -> Copy
 *
 * @param params
 */
// TODO: search and replace all occurrences of this function in the project ???
export const defaultAsyncPost = (params) => {
  const { url, data, callback } = params

  fetchJSONData(url, {}, data, (response) => {
    if (callback) {
      callback(response)
    }

    if (typeof response.url != 'undefined' && response.url != '') {
      window.location.href = response.url
    } else if (typeof response.message != 'undefined' && response.message != '') {
      if (response.status) {
        createAlert(response, 'success')
      } else {
        createAlert(response, 'error')
      }
    }
  })
}
